// export const SEA_TURTLE_WEB_API = "http://localhost:8443/api"; // Local Host

// export const SEA_TURTLE_WEB_API = "http://conruabien.vn:8081/api";  // container env
export const SEA_TURTLE_WEB_API = "https://conruabien.vn/api";  // container env
// export const SEA_TURTLE_WEB_API_DEV = "http://localhost:8083/api"; // Local Host


// ALL PAGE
export const DEFAULT_PAGE = 0;
export const NEXT_PAGE_NUMBER = 1;
export const DEFAULT_PAGE_SIZE = 9;


// PAGE IMAGE
export const DEFAULT_PAGE_IMAGE = 1;
export const DEFAULT_PAGE_SIZE_IMAGE = 15;
export const NEXT_PAGE_SIZE_IMAGE = 3;


export const REGEX_PASSWORD = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}$/;
export const REGEX_PHONE = /^0\d{9}$/;


export const MILISECONDS_PER_DAY = 24 * 60 * 60 * 1000;
export const CATEGORY_ID_WHEN_SELECT_TOPIC = 4;
